//@ts-nocheck
import {ChannelContentProps} from '@app/channels/channel-content';
import {Fragment, useEffect, useRef, useState} from 'react';
// import {useCarousel} from '@app/channels/carousel/use-carousel';
import {Title} from '@app/titles/models/title';
import {Button} from '@common/ui/buttons/button';
import {Trans} from '@common/i18n/trans';
import {TitleBackdrop} from '@app/titles/title-poster/title-backdrop';
import {Link, useNavigate} from 'react-router-dom';
import {useChannelContent} from '@common/channels/requests/use-channel-content';
import {ChannelContentItem} from '@common/channels/channel';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Autoplay, EffectFade} from 'swiper/modules';
import clsx from 'clsx';
import {useThemeSelector} from '@common/ui/themes/theme-selector-context';
import {useSelectedLocale} from '@common/i18n/selected-locale';
import {getBaseMediaLink} from '@app/base-media-link';
// import {slugifyString} from '@common/utils/string/slugify-string';
import {FormattedDate} from '@common/i18n/formatted-date';
import {FormattedDuration} from '@common/i18n/formatted-duration';
import imdbLogo from '../../../public/assets/images/movies/imdb-logo.svg';
import {Microphone} from 'iconsax-react';
import {GoClockFill} from 'react-icons/go';
import {FaCalendarAlt} from 'react-icons/fa';
import {useAuth} from '@common/auth/use-auth';
import {useGetWatchedContent} from '@app/titles/pages/title-page/requests/useGetWatchedContent';
import {WatchedType} from '@app/titles/pages/title-page/requests/types';
import Plus3 from '../../../public/assets/images/age/iCons_3_Plus.png';
import Plus7 from '../../../public/assets/images/age/iCons_7_Plus.png';
// import Plus9 from '../../../public/assets/images/age/iCons_9_Plus.png';
import Plus10 from '../../../public/assets/images/age/iCons_10_Plus.png';
import Plus13 from '../../../public/assets/images/age/iCons_13_Plus.png';
import Plus14 from '../../../public/assets/images/age/iCons_14_Plus.png';
import Plus15 from '../../../public/assets/images/age/iCons_15_Plus.png';
import Plus16 from '../../../public/assets/images/age/iCons_16_Plus.png';
// import Plus17 from '../../../public/assets/images/age/iCons_17_Plus.png';
import Plus18 from '../../../public/assets/images/age/iCons_18_Plus.png';
import Approved from '../../../public/assets/images/age/iCons_Approved.png';
import Nr from '../../../public/assets/images/age/iCons_NR.png';
import {AdHost} from '@common/admin/ads/ad-host';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export function ChannelContentSlider({channel}: ChannelContentProps<Title>) {
  const {data: pagination} =
    useChannelContent<ChannelContentItem<Title>>(channel);
  const {selectedTheme} = useThemeSelector();

  const {isLoggedIn} = useAuth();

  const navigate = useNavigate();

  const {locale} = useSelectedLocale();
  // console.log(pagination?.data);
  const slider = useRef<HTMLDivElement>(null);
  const [key, setKey] = useState(0);
  const watchData = useGetWatchedContent();
  const watchDataList: WatchedType[] = watchData?.data?.data;

  const initSwiper = (swiper: any) => {
    addCustomClassToVisibleSlides(swiper);
  };

  const addCustomClassToVisibleSlides = (swiper: any) => {
    if (slider.current) {
      if (swiper) {
        slider.current
          .querySelectorAll('.swiper-slide')
          .forEach(separateSlide => separateSlide.classList.remove('last'));

        const swiperSlide = slider.current.querySelectorAll(
          '.swiper-slide-visible',
        );

        const lastVisibleSlide = swiperSlide[swiperSlide.length - 1];

        setTimeout(() => {
          if (lastVisibleSlide) {
            lastVisibleSlide.classList.add('swiper-active', 'last');
          }
        }, 0);
      }
    }
  };

  const restrictionSvgPlacer = (certification?: string) => {
    const makePureCertification = certification
      ?.replaceAll(',', '')
      .toLowerCase();
    let svg: string = '';
    switch (makePureCertification) {
      case 'tv-y':
      case 'tv-g':
      case 'y7':
      case 'tv-y7':
      case 'tv-y7-f7':
      case 'g':
        svg = Plus3;
        break;
      case '7':
      case '+7':
      case '7+':
        svg = Plus7;
        break;
      case 'pg':
        svg = Plus10;
        break;
      case 'pg-13':
      case '+13':
        svg = Plus13;
        break;
      case 'tv-14':
      case '14':
        svg = Plus14;
        break;
      case 'ma':
        svg = Plus15;
        break;
      case '+16':
        svg = Plus16;
        break;
      case 'nc-17':
      case 'tv-ma':
      case 'r':
      case '+18':
      case '18+':
        svg = Plus18;
        break;
      case 'nr':
      case 'not rated':
      case 'notrated':
      case 'unrated':
      case 'g':
      case 'gp':
        svg = Nr;
        break;
      case 'approved':
      case 'passed':
        svg = Approved;
        break;
      default:
        svg = Nr;
        break;
    }
    return svg;
  };

  // const shuffle = (array: any) => {
  //   let currentIndex = array.length,
  //     randomIndex;
  //   while (currentIndex !== 0) {
  //     randomIndex = Math.floor(Math.random() * currentIndex);
  //     currentIndex--;
  //     [array[currentIndex], array[randomIndex]] = [
  //       array[randomIndex],
  //       array[currentIndex],
  //     ];
  //   }
  //   return array;
  // };

  // const indexes = [...Array(pagination?.data.length).keys()];
  // const shuffledIndexes = shuffle([...indexes]);
  // const selectedIndexes = shuffledIndexes.slice(0, 10);

  useEffect(() => {
    setKey(prev => prev + 1);
  }, [locale]);

  return (
    <Fragment>
      <div className="-mx-124 md:-mt-48 [@media(max-width:767px)]:-mx-12">
        <Swiper
          key={key}
          navigation={{
            prevEl: '.swiper-banner-button-prev',
            nextEl: '.swiper-banner-button-next',
          }}
          id="home-banner-slider"
          className="iq-main-slider banner-home-swiper wrapper-class mt-15 mb-0 overflow-hidden"
          modules={[Navigation, Autoplay]}
          loop={true}
          wrapperClass="m-0 p-0"
          autoplay={{delay: 10000}}
          initialSlide={1}
        >
          {pagination?.data?.map((item, index) => (
            <SwiperSlide key={index} className="slide s-bg-1 p-0">
              <div className="banner-home-swiper-image">
                <TitleBackdrop
                  title={item}
                  lazy={index > 0}
                  isSlider
                  className="min-h-240 md:min-h-0"
                  wrapperClassName="h-full w-full"
                />
              </div>
              <div className="container-fluid position-relative z-10 h-100 w-full">
                <div className="slider-inner h-100 px-80 max-md:px-0">
                  <div className="row align-items-center iq-ltr-direction h-100">
                    <div className="col-lg-7 col-md-12 mb-10 mt-auto">
                      <h1
                        className="texture-text letter-spacing-1 line-count-1 text-uppercase RightAnimate mb-2 cursor-pointer text-6xl text-[40px] font-bold max-md:text-2xl"
                        onClick={() =>
                          navigate(
                            getBaseMediaLink(
                              // `/titles/${item.url_id}/${slugifyString(item.name)}`,
                              `/titles/${item?.url_id}/data`,
                            ),
                          )
                        }
                      >
                        {locale.language === 'fa' && item?.persian_name
                          ? item?.persian_name
                          : item?.name}
                        {/* <Trans message={item?.name as string} /> */}
                      </h1>
                      <div className="d-flex r-mb-23 RightAnimate-two flex-col flex-wrap">
                        <div className="flex items-center gap-x-20 text-sm">
                          <span className="rateText text-base font-semibold max-md:text-xs">
                            {item?.tmdb_vote_average} / 10
                          </span>
                          <img src={imdbLogo} alt="" />
                          {item?.certification && (
                            <img
                              className="h-38 w-38"
                              src={
                                item?.certification
                                  ? restrictionSvgPlacer(item?.certification)
                                  : Nr
                              }
                              alt=""
                            />
                          )}
                          {item?.runtime && (
                            <div className="flex items-end gap-x-4">
                              <GoClockFill fontSize={30} color="#fff" />
                              <FormattedDuration
                                minutes={item?.runtime}
                                verbose
                              />
                            </div>
                          )}
                        </div>
                        <div className="mt-16 flex items-end gap-x-32">
                          <div className="flex items-end gap-x-4 text-base max-md:text-xs">
                            <Microphone size="30" color="#fff" variant="Bold" />{' '}
                            <Trans
                              message={
                                pagination?.data[
                                  index
                                ]?.language?.toUpperCase() as string
                              }
                            />
                          </div>
                          <div className="flex items-end gap-x-4 text-base max-md:text-xs">
                            <FaCalendarAlt fontSize={28} color="#fff" />
                            <FormattedDate date={item?.release_date} />
                          </div>
                          {/* <div className="flex items-end gap-x-4 text-base max-md:text-xs">
                            <Global size="30" color="#fff" variant="Bold" />
                            lorem
                          </div> */}
                        </div>
                        <div
                          className={clsx(
                            'fw-500 time descriptionText mt-4 text-base max-md:text-xs',
                            locale.language === 'fa' && '!text-right',
                            !selectedTheme.is_dark && 'text-white ',
                          )}
                        >
                          {locale.language === 'fa' && item?.persian_description
                            ? item?.persian_description
                            : item?.description}
                        </div>
                      </div>
                      <div className="trending-list RightAnimate-three">
                        <div className="genres fw-500 text-white"></div>
                      </div>
                      <div className="RightAnimate-four">
                        <div className="iq-button">
                          {item?.primary_video && (
                            <Button
                              variant="flat"
                              color="primary"
                              // startIcon={<MoreIcon />}
                              radius="rounded"
                              className="mt-12 h-[36px] w-[100px] text-base text-white max-md:text-xs md:min-h-42 md:min-w-144"
                              elementType={Link}
                              to={getBaseMediaLink(
                                // `/titles/${item.id}/${slugifyString(item.name)}`,
                                `/titles/${item?.url_id}/data`,
                                {
                                  absolute: true,
                                },
                              )}
                            >
                              <Trans message="Read More" />
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div
            className="swiper-banner-button-prev swiper-nav max-md:hidden"
            id="swiper-banner-button-prev"
          >
            <i></i>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 44 44"
              width="44"
              height="44"
              fill="none"
              stroke="currentColor"
            >
              <circle r="20" cy="22" cx="22"></circle>
            </svg>
          </div>
          <div
            className="swiper-banner-button-next swiper-nav max-md:hidden"
            id="swiper-banner-button-next"
          >
            <i></i>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 44 44"
              width="44"
              height="44"
              fill="none"
              stroke="currentColor"
            >
              <circle r="20" cy="22" cx="22"></circle>
            </svg>
          </div>
        </Swiper>
      </div>
      <AdHost slot="general_bottom" className="my-10 py-24" />
      {isLoggedIn && watchData?.data?.data?.lenght !== 0 && (
        <div className="container-fluid mt-[40px] flex flex-col gap-y-[24px]">
          <div
            className={`d-flex align-items-center justify-content-between px-md-3 mb-4 px-1`}
          >
            <h4
              className={`main-title text-capitalize mb-0 text-sm md:text-2xl ${!selectedTheme.is_dark && 'text-black'}`}
            >
              <Trans message={'Continue Watching'} />
            </h4>
          </div>
          <Swiper
            className={`swiper swiper-card swiper-initialized swiper-horizontal swiper-pointer-events swiper-watch-progress swiper-backface-hidden position-relative !m-0 !mb-0 !ml-0 !mr-0`}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 16,
              },
              576: {
                slidesPerView: 1,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 16,
              },
              1025: {
                slidesPerView: 3,
                spaceBetween: 16,
              },
              1500: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
            }}
            loop
            watchSlidesProgress
            navigation={{
              prevEl: '.swiper-banner-button-prev',
              nextEl: '.swiper-banner-button-next',
            }}
            onSwiper={initSwiper}
            onSlideChange={initSwiper}
            modules={[Autoplay, Navigation]}
          >
            {watchDataList?.map(
              (item, index) =>
                //@ts-expect-error
                (item[0]?.watched !== 0 || item?.watched !== 0) && (
                  <SwiperSlide className="!w-[300px]" tag="li" key={index}>
                    <Link
                      to={`/titles/${item[0]?.title?.url_id || item?.title?.url_id}/data`}
                      className="relative flex h-[200px] w-[300px] cursor-pointer flex-col"
                    >
                      <LazyLoadImage
                        className="w-full object-cover"
                        //@ts-expect-error
                        effect="blur"
                        src={item[0]?.title?.backdrop || item?.title?.backdrop}
                        alt="watched title backdrop"
                      />
                      <div className="absolute bottom-[2rem] left-2 flex items-center gap-x-5 !text-[14px] text-white">
                        <span className="flex items-center gap-x-4">
                          <span>{item[0]?.watched || item?.watched}</span>
                          <span>
                            <Trans message="of" />
                          </span>
                          <span>{item[0]?.duration || item?.duration}</span>
                        </span>
                        {item[0]?.type === 'series' && (
                          <span className="flex items-center gap-x-4">
                            <span>-</span>
                            <span>
                              <Trans message={`S${item[0]?.season}`} />
                            </span>
                            <span>
                              <Trans message={`E${item[0]?.episode}`} />
                            </span>
                          </span>
                        )}
                      </div>
                      <div className="relative h-2 w-full bg-white">
                        <div
                          className="absolute bottom-0 left-0 top-0 h-2 bg-danger-darker"
                          style={{
                            //@ts-expect-error
                            width: `${((item[0]?.watched || item?.watched) / (item[0]?.duration || item?.duration)) * 100}%`,
                          }}
                        ></div>
                      </div>
                    </Link>
                  </SwiperSlide>
                ),
            )}
            <div
              className="swiper-banner-button-prev swiper-nav hidden md:block"
              id="swiper-banner-button-prev"
            >
              <i></i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 44 44"
                width="44"
                height="44"
                fill="none"
                stroke="currentColor"
              >
                <circle r="20" cy="22" cx="22"></circle>
              </svg>
            </div>
            <div
              className="swiper-banner-button-next swiper-nav hidden md:block"
              id="swiper-banner-button-next"
            >
              <i></i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 44 44"
                width="44"
                height="44"
                fill="none"
                stroke="currentColor"
              >
                <circle r="20" cy="22" cx="22"></circle>
              </svg>
            </div>
          </Swiper>
        </div>
      )}
    </Fragment>
  );
}
